/**
 * The onboarding's progress whisper (`.stepline`): a 22×2px dash per step, green on the step on
 * screen, deep green behind it, the border tone ahead. Decorative: the step heading says where
 * the person is.
 */
export function StepLine({ count, current }: { count: number; current: number }) {
  return (
    <div className="mb-7 flex items-center gap-2" aria-hidden="true" data-testid="onboarding-step-line">
      {Array.from({ length: count }, (_, index) => (
        <span
          key={index}
          data-state={index < current ? "done" : index === current ? "current" : "ahead"}
          className="h-[2px] w-[22px] rounded-full transition-colors duration-[var(--tb-duration-2)] ease-[var(--tb-ease-linen)]"
          style={{
            backgroundColor:
              index < current ? "var(--tb-green-deep)" : index === current ? "var(--tb-green)" : "var(--tb-border)",
          }}
        />
      ))}
    </div>
  );
}
